import React from 'react';
import {motion} from 'framer-motion';
import {Card, CardContent} from '../ui/card';
import {Users, Clock, Calendar, FileText, ClipboardList} from 'lucide-react';

const DoctorStatsCards = ({doctorSubmissions, patients = [], appointmentsCount = 0, scheduledAppointmentsCount = 0, submissionsCount = 0, campSubmissionsCount = 0, attendanceCount = 0, onNavigate, canAccessCampSubmissions = false, canAccessAttendance = false}) => {
  return (
    <motion.div
      initial={{opacity: 0, y: 20}}
      animate={{opacity: 1, y: 0}}
      transition={{duration: 0.6, delay: 0.1}}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-3 sm:gap-4 md:gap-6 mb-8"
    >
      <Card 
        className="glass-effect border-gray-700 cursor-pointer hover:border-blue-500 transition-colors"
        onClick={() => onNavigate && onNavigate('patients')}
      >
        <CardContent className="p-4 sm:p-6">
          <div className="flex flex-col">
            <Users className="h-6 w-6 sm:h-8 sm:w-8 text-blue-400 flex-shrink-0 mb-2" />
            <p className="text-gray-400 text-xs sm:text-sm">Total Patients</p>
            <p className="text-xl sm:text-2xl font-bold text-white">
              {patients.length}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card 
        className="glass-effect border-gray-700 cursor-pointer hover:border-purple-500 transition-colors"
        onClick={() => {
          if (onNavigate) {
            onNavigate('appointments');
            // Set filter to scheduled in AppointmentsTab
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('filter-appointments', { detail: { status: 'Scheduled' } }));
            }, 100);
          }
        }}
      >
        <CardContent className="p-4 sm:p-6">
          <div className="flex flex-col">
            <Calendar className="h-6 w-6 sm:h-8 sm:w-8 text-purple-400 flex-shrink-0 mb-2" />
            <p className="text-gray-400 text-xs sm:text-sm">Scheduled</p>
            <p className="text-xl sm:text-2xl font-bold text-white">
              {scheduledAppointmentsCount || 0}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card 
        className="glass-effect border-gray-700 cursor-pointer hover:border-orange-500 transition-colors"
        onClick={() => onNavigate && onNavigate('appointments')}
      >
        <CardContent className="p-4 sm:p-6">
          <div className="flex flex-col">
            <Calendar className="h-6 w-6 sm:h-8 sm:w-8 text-orange-400 flex-shrink-0 mb-2" />
            <p className="text-gray-400 text-xs sm:text-sm">Total Appointments</p>
            <p className="text-xl sm:text-2xl font-bold text-white">
              {appointmentsCount || 0}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card 
        className="glass-effect border-gray-700 cursor-pointer hover:border-blue-500 transition-colors"
        onClick={() => onNavigate && onNavigate('submissions')}
      >
        <CardContent className="p-4 sm:p-6">
          <div className="flex flex-col">
            <FileText className="h-6 w-6 sm:h-8 sm:w-8 text-blue-400 flex-shrink-0 mb-2" />
            <p className="text-gray-400 text-xs sm:text-sm">Appointment History</p>
            <p className="text-xl sm:text-2xl font-bold text-white">
              {submissionsCount || 0}
            </p>
            {doctorSubmissions.filter(s => s.status === 'completed').length > 0 && (
              <p className="text-green-400 text-xs mt-1">
                {doctorSubmissions.filter(s => s.status === 'completed').length} Completed
              </p>
            )}
          </div>
        </CardContent>
      </Card>

      {canAccessCampSubmissions && (
        <Card 
          className="glass-effect border-gray-700 cursor-pointer hover:border-teal-500 transition-colors"
          onClick={() => onNavigate && onNavigate('camp_submissions')}
        >
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col">
              <ClipboardList className="h-6 w-6 sm:h-8 sm:w-8 text-teal-400 flex-shrink-0 mb-2" />
              <p className="text-gray-400 text-xs sm:text-sm">Camp Submissions</p>
              <p className="text-xl sm:text-2xl font-bold text-white">
                {campSubmissionsCount || 0}
              </p>
            </div>
          </CardContent>
        </Card>
      )}

      {canAccessAttendance && (
        <Card 
          className="glass-effect border-gray-700 cursor-pointer hover:border-indigo-500 transition-colors"
          onClick={() => onNavigate && onNavigate('attendance')}
        >
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col">
              <Clock className="h-6 w-6 sm:h-8 sm:w-8 text-indigo-400 flex-shrink-0 mb-2" />
              <p className="text-gray-400 text-xs sm:text-sm">Attendance</p>
              <p className="text-xl sm:text-2xl font-bold text-white">
                {attendanceCount || 0}
              </p>
            </div>
          </CardContent>
        </Card>
      )}
    </motion.div>
  );
};

export default DoctorStatsCards;
